import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function enableReminders() {
  if (!pushSupported()) {
    return { ok: false, error: "Notifications aren't supported on this device/browser. On iPhone, add the app to your Home Screen first." };
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, error: "Notifications were blocked. Enable them in your browser settings." };
  try {
    const reg = await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey),
      });
    }
    await api.post("/push/subscribe", sub.toJSON());
    localStorage.setItem("remindersOn", "1");
    return { ok: true };
  } catch (e) {
    return { ok: false, error: "Couldn't turn on reminders. Try again." };
  }
}
